import { useRef, useState } from 'react'
import { Download } from 'lucide-react'
import { downloadDocument } from '../lib/documentDownloads'

export default function DocumentDownloadButton({ doc, variant = 'signed', onDownloaded, className = 'btn btn-ghost', style, children }) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const active = useRef(false)

  async function startDownload(event) {
    event.stopPropagation()
    if (active.current) return
    active.current = true
    setBusy(true)
    setError('')
    try {
      const result = await downloadDocument(doc, variant)
      if (onDownloaded) Promise.resolve().then(() => onDownloaded(result)).catch(() => {})
    } catch (err) {
      setError(err.message || 'Could not download the document. Please try again.')
    } finally {
      active.current = false
      setBusy(false)
    }
  }

  return <span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start', maxWidth: '100%', gap: 5 }}>
    <button type="button" className={className} disabled={busy} aria-busy={busy} onClick={startDownload} onKeyDown={event => event.stopPropagation()}
      style={{ fontSize: 12, display: 'inline-flex', alignItems: 'center', gap: 6, ...style }}>
      <Download size={14} aria-hidden="true" />
      {busy ? 'Downloading…' : children || (variant === 'signed' ? 'Download signed PDF' : 'Download original')}
    </button>
    {error && <span role="alert" style={{ color: '#991B1B', fontSize: 12, maxWidth: 280, whiteSpace: 'normal' }}>{error}</span>}
  </span>
}
